(function () {
  const selectors = {
    drawer: '[data-cart-drawer]',
    drawerItems: '[data-cart-items]',
    subtotal: '[data-cart-subtotal]',
    count: '[data-cart-count]',
    empty: '[data-cart-empty]',
    filled: '[data-cart-filled]',
    meter: '[data-shipping-meter]',
    shippingMsg: '[data-shipping-message]',
    toast: '[data-nv-toast]',
    quiz: '[data-routine-quiz]',
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    } catch (_) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  })[character]);

  const renderProperties = (properties) => {
    const publicProperties = Object.entries(properties || {}).filter(([name, value]) => (
      name.charAt(0) !== '_' && value !== null && value !== undefined && String(value).trim() !== ''
    ));

    if (!publicProperties.length) return '';

    return `<div style="color:var(--muted);font-size:12px;margin-top:6px;">${publicProperties.map(([name, value]) => (
      `<div><strong>${escapeHtml(name)}:</strong> ${escapeHtml(value)}</div>`
    )).join('')}</div>`;
  };

  const rootUrl = () => (window.Shopify?.routes?.root || '/');
  const bookingUrl = 'https://www.nuvitru.com/book';

  const normalizeBookingLinks = () => {
    document.querySelectorAll('a[href="https://www.nuvitru.com/clinic"], a[href="https://nuvitru.com/clinic"], a[href="http://www.nuvitru.com/clinic"], a[href="http://nuvitru.com/clinic"]').forEach((link) => {
      link.href = bookingUrl;
    });
  };

  const toast = (message) => {
    const el = document.querySelector(selectors.toast);
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(toast.timer);
    toast.timer = window.setTimeout(() => el.classList.remove('is-visible'), 2400);
  };

  const openDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  const renderCart = (cart) => {
    document.querySelectorAll(selectors.count).forEach((el) => el.setAttribute('data-count', String(cart.item_count || 0)));
    document.querySelectorAll(selectors.count).forEach((el) => { el.textContent = cart.item_count || 0; });

    const empty = document.querySelector(selectors.empty);
    const filled = document.querySelector(selectors.filled);
    if (empty && filled) {
      empty.hidden = cart.item_count > 0;
      filled.hidden = cart.item_count === 0;
    }

    const list = document.querySelector(selectors.drawerItems);
    if (list) {
      list.innerHTML = cart.items.map((item, index) => {
        const isAnnualProgram = item.product_type === 'Annual Program';
        const controls = isAnnualProgram
          ? `<div class="cart-line__controls">
              <span>${item.quantity === 1 ? '1 enrollment' : `${item.quantity} enrollments`}</span>
              <button type="button" data-cart-change="${index + 1}" data-qty="0" style="margin-left:auto;width:auto;padding:0 10px;">Remove</button>
            </div>`
          : `<div class="cart-line__controls">
              <button type="button" data-cart-change="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              <button type="button" data-cart-change="${index + 1}" data-qty="0" style="margin-left:auto;width:auto;padding:0 10px;">Remove</button>
            </div>`;

        return `
          <div class="cart-line" data-line="${index + 1}">
            <div class="cart-line__media">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}</div>
            <div>
              <div class="cart-line__title">${escapeHtml(item.product_title)}</div>
              <div style="color:var(--muted);font-size:12px;margin-top:3px;">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : ''}</div>
              ${renderProperties(item.properties)}
              <div style="font-weight:700;color:var(--ink);margin-top:6px;">${escapeHtml(money(item.final_line_price))}</div>
              ${controls}
            </div>
          </div>
        `;
      }).join('');
    }

    const subtotal = document.querySelector(selectors.subtotal);
    if (subtotal) subtotal.textContent = money(cart.total_price);

    const threshold = Number(document.body.dataset.freeShippingThreshold || 99) * 100;
    const meter = document.querySelector(selectors.meter);
    const msg = document.querySelector(selectors.shippingMsg);
    const shippableItems = cart.items.filter((item) => item.requires_shipping);
    const shippableSubtotal = shippableItems.reduce((total, item) => total + item.final_line_price, 0);
    const hasAnnualProgram = cart.items.some((item) => item.product_type === 'Annual Program');
    if (meter) meter.style.width = Math.min(100, Math.round(shippableSubtotal / threshold * 100)) + '%';
    if (msg) {
      const left = Math.max(0, threshold - shippableSubtotal);
      msg.textContent = cart.items.length > 0 && shippableItems.length === 0 && hasAnnualProgram
        ? 'Annual program enrollment does not require shipping'
        : left > 0 ? `You're ${money(left)} away from free shipping` : 'Your order ships free';
    }
  };

  const fetchCart = () => fetch(rootUrl() + 'cart.js').then((res) => res.json()).then((cart) => {
    renderCart(cart);
    return cart;
  });

  const addToCart = (variantId, quantity) => fetch(rootUrl() + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] }),
  }).then((res) => {
    if (!res.ok) return res.json().then((err) => Promise.reject(err));
    return res.json();
  }).then(() => fetchCart()).then(() => {
    toast('Added to cart');
    openDrawer();
  }).catch((err) => {
    toast(err?.description || 'Could not add this item');
  });

  const addAnnualProgramToCart = (form) => {
    if (form.dataset.submitting === 'true') return Promise.resolve();

    const formData = new FormData(form);
    formData.set('quantity', '1');
    const variantId = Number(formData.get('id'));
    const submit = form.querySelector('[type="submit"]');
    const submitWasDisabled = submit?.disabled || false;

    if (!variantId) {
      toast('Could not identify this program');
      return Promise.resolve();
    }

    form.dataset.submitting = 'true';
    if (submit) submit.disabled = true;

    return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        const updates = {};
        cart.items
          .filter((item) => Number(item.id) === variantId)
          .forEach((item) => { updates[item.key] = 0; });

        if (!Object.keys(updates).length) return null;

        return fetch(rootUrl() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates }),
        }).then((res) => {
          if (!res.ok) return res.json().then((err) => Promise.reject(err));
          return res.json();
        });
      })
      .then(() => fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
      }))
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then(() => fetchCart())
      .then(() => {
        toast('Program added to cart');
        openDrawer();
      })
      .catch((err) => {
        toast(err?.description || 'Could not add this program');
      })
      .finally(() => {
        delete form.dataset.submitting;
        if (submit) submit.disabled = submitWasDisabled;
      });
  };

  const changeCart = (line, quantity) => fetch(rootUrl() + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
  }).then((res) => res.json()).then(renderCart);

  const initProductGalleries = () => {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const current = gallery.querySelector('[data-gallery-current]');
      if (!slides.length) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      const pauseInactiveMedia = () => {
        slides.forEach((slide, index) => {
          if (index === activeIndex) return;
          slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };

      const show = (requestedIndex) => {
        activeIndex = (requestedIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((thumb, index) => {
          const active = index === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (current) current.textContent = String(activeIndex + 1);
        pauseInactiveMedia();
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => show(index));
      });
      previous?.addEventListener('click', () => show(activeIndex - 1));
      next?.addEventListener('click', () => show(activeIndex + 1));
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(activeIndex + 1);
        }
      });
      show(activeIndex);
    });
  };

  const openQuiz = () => {
    const quiz = document.querySelector(selectors.quiz);
    if (!quiz) return;
    quiz.classList.add('is-open');
    quiz.setAttribute('aria-hidden', 'false');
    quiz.querySelector('[data-quiz-step="1"]')?.removeAttribute('hidden');
    quiz.querySelector('[data-quiz-step="2"]')?.setAttribute('hidden', '');
    quiz.querySelector('[data-quiz-result]')?.setAttribute('hidden', '');
  };

  const closeQuiz = () => {
    const quiz = document.querySelector(selectors.quiz);
    if (!quiz) return;
    quiz.classList.remove('is-open');
    quiz.setAttribute('aria-hidden', 'true');
  };

  document.addEventListener('click', (event) => {
    normalizeBookingLinks();

    const open = event.target.closest('[data-open-cart]');
    if (open) { event.preventDefault(); fetchCart().then(openDrawer); return; }

    const close = event.target.closest('[data-close-cart]');
    if (close) { event.preventDefault(); closeDrawer(); return; }

    const add = event.target.closest('[data-add-to-cart]');
    if (add) { event.preventDefault(); addToCart(add.dataset.variantId, add.dataset.quantity || 1); return; }

    const formButton = event.target.closest('[data-product-submit]');
    if (formButton) {
      const form = formButton.closest('form');
      const variant = form?.querySelector('[name="id"]')?.value;
      const qty = form?.querySelector('[name="quantity"]')?.value || 1;
      if (variant) { event.preventDefault(); addToCart(variant, qty); }
      return;
    }

    const change = event.target.closest('[data-cart-change]');
    if (change) { event.preventDefault(); changeCart(change.dataset.cartChange, change.dataset.qty); return; }

    const quizOpen = event.target.closest('[data-open-quiz]');
    if (quizOpen) { event.preventDefault(); openQuiz(); return; }

    const quizClose = event.target.closest('[data-close-quiz]');
    if (quizClose) { event.preventDefault(); closeQuiz(); return; }

    const quizOption = event.target.closest('[data-quiz-concern]');
    if (quizOption) {
      const quiz = document.querySelector(selectors.quiz);
      quiz.querySelectorAll('[data-quiz-concern]').forEach((btn) => btn.classList.remove('is-selected'));
      quizOption.classList.add('is-selected');
      quiz.dataset.concern = quizOption.dataset.quizConcern;
      quiz.querySelector('[data-quiz-step="1"]')?.setAttribute('hidden', '');
      quiz.querySelector('[data-quiz-step="2"]')?.removeAttribute('hidden');
      return;
    }

    const quizDepth = event.target.closest('[data-quiz-depth]');
    if (quizDepth) {
      const quiz = document.querySelector(selectors.quiz);
      const concern = quiz.dataset.concern || 'foundations';
      const label = quiz.querySelector(`[data-quiz-concern="${concern}"] strong`)?.textContent || 'Foundations';
      const result = quiz.querySelector('[data-quiz-result]');
      quiz.querySelector('[data-quiz-step="2"]')?.setAttribute('hidden', '');
      result?.removeAttribute('hidden');
      const link = result?.querySelector('[data-quiz-link]');
      const title = result?.querySelector('[data-quiz-title]');
      if (title) title.textContent = `${label}: start with the curated shelf`;
      if (link) link.href = `/collections/all/${concern}`;
    }
  });

  document.addEventListener('submit', (event) => {
    const annualForm = event.target.closest('[data-annual-program-form]');
    if (annualForm) {
      event.preventDefault();
      addAnnualProgramToCart(annualForm);
      return;
    }

    const form = event.target.closest('[data-nv-product-form]');
    if (!form) return;
    const submit = form.querySelector('[data-product-submit]');
    if (submit) submit.click();
    event.preventDefault();
  });

  document.addEventListener('DOMContentLoaded', () => {
    normalizeBookingLinks();
    fetchCart();
    initProductGalleries();
  });
})();
